<!-- **** --------------------------------------------------------------------------
	SHARED SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts">
    const component = {
        name: 'ColorPicker_Swatch',
    };
    export default {
        name: component.name,
    };
</script>

<!-- **** --------------------------------------------------------------------------
	SCRIPT
-------------------------------------------------------------------------- **** -->
<script lang="ts" setup>
    const props = withDefaults(
        defineProps<{
            color: (HSLArray | (HSLArray & number[])) | string;
            click?: () => void;
        }>(),
        {}
    );
</script>

<!-- **** --------------------------------------------------------------------------
	TEMPLATE
-------------------------------------------------------------------------- **** -->
<template>
    <div class="cp-swatch" :style="{ backgroundColor: `hsl(${color[0]}, ${color[1]}%, ${color[2]}%, ${color[3] ?? 100}%)` }"></div>
</template>

<!-- **** --------------------------------------------------------------------------
	STYLES
-------------------------------------------------------------------------- **** -->
<style>
    .cp-swatch {
        height: 100%;
        width: 100%;
        border-radius: 3px;
        box-shadow: inset 1px 1px 4px 1px #0000002e;

        cursor: pointer;
    }
</style>
